export default {
    setIsLoggedIn: (state, data) => {
      state.isLoggedIn = data;
    },
};
